import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import AdminVideo from "./AdminVideo";

const AdminAddNewVideo = (props) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Add Video
                  <div className="mt-2 f10-400">
                    Added video will be displayed in the tracker screen of the
                    user app
                  </div>
                </div>
              </div>
              <AdminVideo
                edit={history?.location?.state?.edit || false}
                editData={history?.location?.state?.data}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AdminAddNewVideo;
